import { Navigate, useRoutes } from 'react-router-dom';

import SimpleLayout from 'layouts/simple';

import HomePage from 'pages/HomePage';
import CurrencyPairPage from 'pages/CurrencyPairPage';
import PrivacyPage from 'pages/PrivacyPage';
import TermsPage from 'pages/TermsPage';
import Page404 from 'pages/Page404';

export default function Router() {
    const routes = useRoutes([
        {
            path: '/',
            element: <SimpleLayout />,
            children: [
                { element: <HomePage />, index: true },
            ],
        },
        {
            path: '/currency-pair/:currencyPair',
            element: <SimpleLayout />,
            children: [
                { element: <CurrencyPairPage/>, index: true },
            ],
        },
        {
            path: '/404',
            element: <SimpleLayout />,
            children: [
                { element: <Page404 />, index: true },
            ],
        },
        {
            path: '/terms-and-conditions',
            element: <SimpleLayout />,
            children: [
                { element: <TermsPage />, index: true },
            ],
        },
        {
            path: '/privacy-policy',
            element: <SimpleLayout />,
            children: [
                { element: <PrivacyPage />, index: true },
            ],
        },
        {
            path: '*',
            element: <Navigate to="/404" replace />,
        },
    ]);

    return routes;
}
